import React, { useEffect, useMemo, useState } from 'react';
import { Button, Table } from 'antd';
import { useFailedTicket } from 'pages/store';
import moment from 'moment';
import { Typography } from 'antd';
import { Offcanvas } from 'react-bootstrap';
import FailedTicketFilter from './FailedTicketFilter';
import { getCurrentUserRole, removeSpaces } from 'modules/utilities/utility';
import { DeleteOutlined, RedoOutlined } from '@ant-design/icons';
import { categoryMap, subCategoryMap } from 'modules/navbar/top/helper';
import { useCreateTicket } from 'modules/CreateTicket/store';
const { Link } = Typography;

const FailedTicket = ({ tab }) => {
    const userRole = getCurrentUserRole();
    const { createTicket, ticketLoading } = useCreateTicket();
    const { fetchAllFailed, failedTicketData, deleteTicketBackup } = useFailedTicket();

    const columns = [
        { title: 'Name', width: 150, dataIndex: 'name', fixed: 'left' },
        { title: 'Category', width: 150, dataIndex: 'category', fixed: 'left' },
        { title: 'SubCategory', width: 150, dataIndex: 'subCategory', fixed: 'left' },
        { title: 'OrderDisplayId', width: 150, dataIndex: 'orderDisplayId' },
        { title: 'Source', width: 150, dataIndex: 'source' },
        { title: 'CreatedAt', width: 200, dataIndex: 'createdAt' },
        { title: 'UpdatedAt', width: 200, dataIndex: 'updatedAt' },
        { title: 'Delete', width: 100, dataIndex: '',key: 'x',render: (ticket) => <Button danger onClick={()=>{deleteTicket(ticket.key)}}><DeleteOutlined /></Button>, fixed: 'right'},
        { title: 'Retry', width: 100, dataIndex: '',key: 'x',render: (ticket) => <Button primary loading={ticket.key === ticketLoading} onClick={()=>{createTicket(ticket.payload, ticket.key)}}><RedoOutlined /></Button>, fixed: 'right'},
    ];
    const superAdminColumns = [
        { title: 'Payload', width: 150, dataIndex: '_payload' },
        { title: 'Error', width: 150, dataIndex: 'error' },
    ]
    userRole === 'super_admin' ? columns.splice(5,0, ...superAdminColumns): columns;

    const endDate = moment().endOf('day').toISOString();;
	const startDate = moment().add(1, 'day').startOf('day').subtract(1, 'days').toISOString();;
	const [failedTicketsCount, setFailedTicketsCount] = useState([]);
	const [startDateFilter, setStartDateFilter] = useState(startDate);
	const [endDateFilter, setEndDateFilter] = useState(endDate);
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [selectedSubCategory, setSelectedSubCategory] = useState(null);
	const [newPage, setNewPage] = useState(1);
	const [query, setQuery] = useState('');

	const startTicketDate = endDate;
	const endTicketDate = startDate;
	useEffect(() => {
        fetchAllFailedTicket();
	}, [startDateFilter, endDateFilter, startTicketDate, endTicketDate, tab, newPage, query]);
    let inputQuery;
    const fetchAllFailedTicket = () =>{
        const sd = startDateFilter || startTicketDate;
        const ed = endDateFilter || endTicketDate;
		fetchAllFailed(sd, ed, newPage, query);
    }
	const failedTickets = useMemo(() => {
		const {failedTicket, failedTicketCount} = failedTicketData;
		if(failedTicket && failedTicketCount){
			setFailedTicketsCount(failedTicketCount);
			const tableData = failedTicket.map(ticket => {
				const data = {
					key: ticket._id,
					name: <Link href={`/lead-details/${ticket.case_id}`} target='_blank'> {_.get(ticket, ['customer', 'first_name'], '')} </Link>,
					category:  _.get(categoryMap, ticket.category, ticket.category),
					subCategory: _.get(subCategoryMap, ticket.sub_category, ticket.sub_category),
					orderDisplayId: _.get(ticket, ['order_display_id'], ''),
					source: _.get(ticket, ['source'], ''),
					createdAt: moment(ticket.createdAt).format('YYYY-MM-DD HH:mm:ss'),
					updatedAt: moment(ticket.updatedAt).format('YYYY-MM-DD HH:mm:ss')
				};
				if(userRole === 'super_admin'){
					data.payload = _.get(ticket, ['payload'], {});
					data._payload = <PayloadFunction data={_.get(ticket, ['payload'], {})} button={'primary'}/>;
					data.error = <PayloadFunction data={{ error: _.get(ticket, ['error'], {}) }} button={'danger'}/>;
				}
				return data;
			});
			return tableData;
		}
		return [];
	}, [failedTicketData]);

    const deleteTicket = (key) => {
        deleteTicketBackup(key);
        fetchAllFailedTicket();
    }
	const handleSearch = query => {
		inputQuery = removeSpaces(query);
		handleFilterClick();
	};
	const handleFilterClick = () => {
		let filter = '';
		let selectedCategoryData = selectedCategory;
		let selectedSubCategoryData = selectedSubCategory;

		if (selectedCategoryData && selectedCategoryData.length > 0) {
			const category = selectedCategoryData.join(',');
			filter += `&category=${category}`;
		}

		if (selectedSubCategoryData && selectedSubCategoryData.length > 0) {
			filter += `&subCategory=${selectedSubCategoryData.join(',')}`;
		}

		if (inputQuery && inputQuery.length > 0) {
			const searchBy = inputQuery;
			const searchQuery = searchBy.startsWith('#') ? searchBy.replace('#', 'oid') : searchBy;
			filter += filter.length > 0 ? `&searchBy=${searchQuery}` : `searchBy=${searchQuery}`;
		}
		setQuery(filter);
		setNewPage(1);
	};
	return (
		<div>
			<FailedTicketFilter
				handleSearch={handleSearch}
				selectedCategory={selectedCategory}
				selectedSubCategory={selectedSubCategory}
				setSelectedCategory={setSelectedCategory}
				setSelectedSubCategory={setSelectedSubCategory}
				handleFilterClick={handleFilterClick}
                setStartDateFilter={setStartDateFilter}
                setEndDateFilter={setEndDateFilter}
			/>
			<Table
                size='small'
				columns={columns}
				dataSource={failedTickets}
				pagination={{total: failedTicketsCount, onChange: (page) => setNewPage(page)}}
                scroll={{x: 1300}}
			/>
		</div>
	);
};

const PayloadFunction = ({ data, button }) => {
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	return (
		<>
			<Button
				onClick={handleShow}
				danger={button === 'danger'}>
				{button === 'danger' ? 'Error' : 'Payload'}
			</Button>
			<Offcanvas
				show={show}
				onHide={handleClose}
				placement={'end'}
				style={{ width: '40vw' }}>
				<Offcanvas.Header closeButton>
					<Offcanvas.Title>Payload</Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body>
					<pre style={button === 'danger' ? { color: 'red' } : {}}>
						{JSON.stringify(data, null, 2)}
					</pre>
				</Offcanvas.Body>
			</Offcanvas>
		</>
	);
};

export default FailedTicket;
